import { Toast } from "vant";
import qs from "./qs";

let isAlertShow = false;
export default {
  qs,
  /*
   * 切分金额补逗号
   * */
  moneySplit(money) {
    let result = money;
    try {
      result = money.toString().replace(/(\d)(?=(\d{3})+$)/g, "$1,");
    } catch (e) {
      // 错误不处理
    }
    return result;
  },
  /**
   * 操作日志打印
   * @param message
   * @param type
   */
  doLog(message, type = "log") {
    try {
      window.console[type](
        `[gnh-${type} ${new Date().toLocaleString()}]: ${message}`
      );
    } catch (e) {
      // do nothing
    }
  },
  /**
   * 控制全局每次只会出现一个 toast
   * @returns {Promise.<void>}
   */
  async singleToast(content) {
    if (!isAlertShow) {
      isAlertShow = true;
      await Toast({
        duration: 1500, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        message: content,
      });
      isAlertShow = false;
    }
  },
  /**
   * 转换活动时间
   * @param 时间戳
   * @returns {{timeStr: string, yearStr: string, str: string,
   *          year: number, month: *, day: *, h: *, mm: *, s: *}}
   */
  setTime(time) {
    if (!time) return "";
    // 时间转换添加0
    function add0(m) {
      return m < 10 ? `0${m}` : m;
    }

    const date = time ? new Date(window.parseInt(time)) : new Date();
    const year = date.getFullYear();
    const month = add0(date.getMonth() + 1);
    const day = add0(date.getDate());
    const h = add0(date.getHours());
    const mm = add0(date.getMinutes());
    const s = add0(date.getSeconds());
    const str = `${month}月${day}日`;
    const yearStr = `${year}年${month}月`;
    const timeStr = `${year}-${month}-${day}`;
    const timeStrAll = `${year}-${month}-${day} ${h}:${mm}:${s}`;
    return {
      timeStrAll,
      timeStr,
      yearStr,
      str,
      year,
      month,
      day,
      h,
      mm,
      s,
    };
  },
  /**
   *
   * @param func    {Function}   实际要执行的函数
   * @param wait    {Number}     执行间隔，单位是毫秒（ms），默认1000ms
   * @param wait    {Object}     leading 前置执行
   * @return        {Function}   返回一个“节流”函数
   */

  throttle(func, wait = 1000, leading = true) {
    // 利用闭包保存定时器和上次执行时间
    let timer = null;
    let previous; // 上次执行时间
    return function () {
      // 保存函数调用时的上下文和参数，传递给 fn
      const context = this;
      const args = arguments;
      const now = +new Date();
      if (previous && now < previous + wait) {
        if (leading) return;
        // 周期之中
        clearTimeout(timer);
        timer = setTimeout(function () {
          previous = now;
          func.apply(context, args);
        }, wait);
      } else {
        previous = now;
        func.apply(context, args);
      }
    };
  },
  /**
   * @param     func     {Function}   实际要执行的函数
   * @param     delay    {Number}     延迟时间，单位是毫秒（ms）
   * @return    {Function} 去抖动
   */

  debounce(fn, delay = 1000) {
    let timer;

    // 返回一个函数，这个函数会在一个时间区间结束后的 delay 毫秒时执行 func 函数
    return function () {
      // 保存函数调用时的上下文和参数，传递给func
      var context = this;
      var args = arguments;

      // 函数被调用，清除定时器
      clearTimeout(timer);

      // 当返回的函数被最后一次调用后（也就是用户停止了某个连续的操作），
      // 再过 delay 毫秒就执行 func
      timer = setTimeout(function () {
        fn.apply(context, args);
      }, delay);
    };
  },
};
